import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import './Modelo.scss';
import Currency from '../Currency';
import expomovil from '../../images/logo_expomovil_2023.svg';
import electricIcon from '../../images/ic_elect_azul.svg';
import cx from 'classnames';
import Badge from '../Badge';

const Modelo = ({ modelo }) => {
  const match = useRouteMatch();
  const hasSlash = match?.url[match?.url.length - 1] === '/';
  const isElectric = modelo.clasificacion === 'ELECTRICO';
  const expoMovilOn = modelo.mostrarExpomovil === '1';

  return (
    <div className={
      cx('categoria-detail__modelo', {
        'categoria-detail__modelo__electrico': isElectric,
      })} key={modelo.codigo}>
      {modelo.nuevo === '1' && <Badge message="Nuevo" left />}
      <Link
        to={`${match.url}${hasSlash ? '' : '/'}${modelo.modelo}/`}
        className="categoria-detail__container"
      >
        <div className="categoria-detail__general">
          <div className="categoria-detail__marca" >
            {modelo.modelo}</div>
          <div className="categoria-detail__precio" >
            <div className="categoria-detail__desde">
              Desde
            </div>
            <Currency value={modelo.precioOferta || modelo.precioPublico} />
          </div>
        </div>
        <div className="categoria-detail__image-container">
          <img
            className="categoria-detail__image"
            src={modelo.imagenPequena}
            alt={modelo.modelo}
          />
        </div>
      </Link>
      <div className="categoria-detail__opciones">
        {(expoMovilOn && isElectric) ? (
          <>
            <div className="categoria-detail__two_icons">
              <div className="categoria-detail__two_icons-img-top">
                <img src={expomovil} alt="Expomovil" width='120'/>
              </div>
              <div className="categoria-detail__two_icons-img-bottom">
                <img src={electricIcon} alt="electricIcon" />
              </div>
            </div>
          </>
        ) : (
          <>
            {expoMovilOn && (
              <div className="categoria-detail__button">
                <img src={expomovil} alt="Expomovil" width='120' />
              </div>
            )}

            {isElectric && (
              <div className="categoria-detail__button">
                <img src={electricIcon} alt="electricIcon" />
              </div>
            )}
          </>
        )}

        {/* {modelo.tourVirtual && (
            <ButtonWithTooltip
              tooltip="Tour Virtual"
              onClick={() => {
                setTourUrl(modelo.tourVirtual);
                console.log(modelo.tourVirtual);
              }}
            >
              <img src={tourVirtualIcon} alt="Tour virtual" />
            </ButtonWithTooltip>
          )} */}
        {/* <div className="categoria-detail__button">
          <ButtonWithTooltip tooltip="Video llamada">
            <img src={videollamadaIcon} alt="Tour virtual" />
          </ButtonWithTooltip>
        </div> */}
      </div>
    </div>
  );
};

export default Modelo;
